export const productShortName = 'Industrial Hydraulics & Pneumatics — Professional Edition™';
export const productBrand = 'Industrial Hydraulics & Pneumatics';
export const productEdition = 'Professional Edition™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/2AmiZ2iAPHxDC5nh91zzPJ/MOCKUP_HYDRAULICS.png';
export const productImageAlt =
  'Industrial Hydraulics & Pneumatics Professional Edition: a 6-volume technical collection shown as navy hardcover books with gold lettering and a hydraulic power unit illustration';

export const backgroundTexture = 'https://cdn.magicpatterns.com/patterns/generated-images/cff6e02b-8842-42c1-88b1-d359f05ce06b.jpg';

export const checkoutUrl = 'https://industrial-hydraulics-pneumatics.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more hours of downtime chasing the wrong fault',
  'No more replacing pumps, valves and cylinders without finding the real cause',
  'No more schematics you can’t read with confidence',
  'No more guessing about fluids, filtration and contamination',
  'No more working around stored pressure without a safe procedure',
];
